import { SimplePool } from 'nostr-tools';

/**
 * Singleton instance of SimplePool
 * This ensures only one pool is created and shared across all components
 * Prevents memory leaks from multiple WebSocket connections
 */
let poolInstance: SimplePool | null = null;

/**
 * Get or create the singleton SimplePool instance
 * @returns The shared SimplePool instance
 */
export const getNostrPool = (): SimplePool => {
    if (!poolInstance) {
        poolInstance = new SimplePool();
    }
    return poolInstance;
};

/**
 * Close and reset the pool (useful for cleanup or testing)
 */
export const resetNostrPool = (): void => {
    if (poolInstance) {
        poolInstance.close([]);
        poolInstance = null;
    }
};
